// extracted by mini-css-extract-plugin
module.exports = {"block":"block-b_block__SdJYA","item":"block-b_item__1qVFN"};